export default __webpack_public_path__ + "assets/universityOfBritishColumbia.png";